import React, { useEffect, useMemo } from "react";
import "../styles/incident.css";

const emptyRow = {
  areaForImprovement: "",
  actionPlan: "",
  responsibility: "",
  targetDate: ""
};

const ActionPlan = ({ data, onChange, isActionPlanLineButtons }) => {
  const actionPlanData = useMemo(
    () => (Array.isArray(data) ? data : []),
    [data]
  );

  useEffect(() => {
    if (isActionPlanLineButtons && actionPlanData.length === 0) {
      onChange([{ ...emptyRow }]);
    }
  }, [actionPlanData.length, isActionPlanLineButtons, onChange]);

  const handleAddRow = (currentData = actionPlanData) => {
    onChange([...currentData, { ...emptyRow }]);
  };

  const handleInputChange = (index, field, value) => {
    const updated = actionPlanData.map((item, i) =>
      i === index ? { ...item, [field]: value } : item
    );

    const lastRow = updated[updated.length - 1];
    const isFilled =
      lastRow.areaForImprovement ||
      lastRow.actionPlan ||
      lastRow.responsibility ||
      lastRow.targetDate;

    if (index === updated.length - 1 && isFilled && updated.length < 20) {
      handleAddRow(updated);
      return;
    }

    onChange(updated);
  };

  const handleRemoveRow = (index) => {
    if (actionPlanData.length === 1) return;

    const updated = actionPlanData.filter((_, i) => i !== index);
    onChange(updated);
  };

  const formatDate = (date) => {
    if (!date) return "";

    try {
      return new Date(date).toISOString().split("T")[0];
    } catch {
      return "";
    }
  };

  const visibleRows = isActionPlanLineButtons
    ? actionPlanData
    : actionPlanData.filter((item) =>
        item.areaForImprovement || item.actionPlan || item.responsibility || item.targetDate
      );

  return (
    <div className="form-container compact">
      <div className="table-responsive">
        <table className="table table-bordered table-sm align-middle">
          <thead className="table-light">
            <tr>
              <th style={{ width: "25%" }}>Area</th>
              <th style={{ width: "30%" }}>Action</th>
              <th style={{ width: "20%" }}>Responsibility</th>
              <th style={{ width: "15%" }}>Date</th>
              {isActionPlanLineButtons && <th style={{ width: "10%" }}></th>}
            </tr>
          </thead>

          <tbody>
            {visibleRows.map((item, index) => (
              <tr key={index}>
                <td>
                  <input
                    className="form-control form-control-sm"
                    placeholder="Area for improvement"
                    value={item.areaForImprovement || ""}
                    disabled={!isActionPlanLineButtons}
                    onChange={(e) =>
                      handleInputChange(index, "areaForImprovement", e.target.value)
                    }
                  />
                </td>

                <td>
                  <input
                    className="form-control form-control-sm"
                    placeholder="Action plan"
                    value={item.actionPlan || ""}
                    disabled={!isActionPlanLineButtons}
                    onChange={(e) =>
                      handleInputChange(index, "actionPlan", e.target.value)
                    }
                  />
                </td>

                <td>
                  <input
                    className="form-control form-control-sm"
                    placeholder="Responsible person"
                    value={item.responsibility || ""}
                    disabled={!isActionPlanLineButtons}
                    onChange={(e) =>
                      handleInputChange(index, "responsibility", e.target.value)
                    }
                  />
                </td>

                <td>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    value={formatDate(item.targetDate)}
                    disabled={!isActionPlanLineButtons}
                    onChange={(e) =>
                      handleInputChange(index, "targetDate", e.target.value)
                    }
                  />
                </td>

                {isActionPlanLineButtons && (
                  <td className="text-center">
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => handleRemoveRow(index)}
                    >
                      X
                    </button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {isActionPlanLineButtons && (
        <div className="mt-2">
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            onClick={() => handleAddRow()}
          >
            + Add Row
          </button>
        </div>
      )}
    </div>
  );
};

export default ActionPlan;
